import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RuleInput, RulesSliceState } from "./rules-interface";
import { fetchRules, fetchRulesById } from "./rules-async-calls";

const initialState: RulesSliceState = {
  rules: [],
  selectedRule: null,
  selectedRuleInputsData: [],
  selectedRuleBody: "",
  isFetching: false,
};

const rulesSlice = createSlice({
  name: "rules",
  initialState,
  reducers: {
    setSelectedRuleInputData: (state, action: PayloadAction<RuleInput[]>) => {
      state.selectedRuleInputsData = action.payload;
    },
    setSelectedRuleBody: (state, action: PayloadAction<string>) => {
      state.selectedRuleBody = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchRules.pending, (state) => {
        state.rules = [];
        state.isFetching = true;
      })
      .addCase(fetchRules.fulfilled, (state, action) => {
        state.rules = action.payload;
        state.isFetching = false;
      })
      .addCase(fetchRules.rejected, (state) => {
        state.rules = [];
        state.isFetching = false;
      })
      .addCase(fetchRulesById.pending, (state) => {
        state.selectedRule = null;
        state.selectedRuleInputsData = [];
        state.selectedRuleBody = "";
        state.isFetching = true;
      })
      .addCase(fetchRulesById.fulfilled, (state, action) => {
        state.selectedRule = action.payload;
        state.selectedRuleInputsData = action.payload.ruleInputs;
        state.selectedRuleBody = action.payload.ruleBody?.ruleBody;
        state.isFetching = false;
      })
      .addCase(fetchRulesById.rejected, (state) => {
        state.selectedRule = null;
        state.selectedRuleInputsData = [];
        state.selectedRuleBody = "";
        state.isFetching = false;
      });
  },
});

export const { setSelectedRuleInputData, setSelectedRuleBody } =
  rulesSlice.actions;

export default rulesSlice.reducer;
